import React, { useMemo, useState } from "react";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../components/CustomButtons/Button";
import DialogContent from "@mui/material/DialogContent";
import CustomSwitch from "../../../components/CustomInput/CustomSwitch";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import { Close } from "@mui/icons-material";
import { FormLabel } from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import { useFormContext } from "react-hook-form";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

function CopyVrijeOpties(props) {
  const { menukaartVestigingId, reloadDataFromServer } = useFormContext();
  const [saving, setSaving] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedMenukaart, setSelectedMenukaart] = useState(null);
  const [useMenukaarten, setUseMenukaarten] = useState(false);
  const [includeTitles, setIncludeTitles] = useState(true);
  const [copyTo, setCopyTo] = useState([
    "freeOptions",
    "freeOptions2",
    "freeOptions3",
    "freeOptionsRequired",
    "freeOptionsRequired2",
    "freeOptionsRequired3",
  ]);

  const titles = {
    freeOptions: "freeOptionsTitle",
    freeOptions2: "freeOptionsTitle2",
    freeOptions3: "freeOptionsTitle3",
    freeOptionsRequired: "freeOptionsRequiredTitle",
    freeOptionsRequired2: "freeOptionsRequiredTitle2",
    freeOptionsRequired3: "freeOptionsRequiredTitle3",
  };

  const copyTofields = useMemo(
    () => [
      "freeOptions",
      "freeOptions2",
      "freeOptions3",
      "freeOptionsRequired",
      "freeOptionsRequired2",
      "freeOptionsRequired3",
    ],
    []
  );

  const copyToFieldsNames = useMemo(
    () => [
      getTranslation("producten.form.vrijeopties.label.freeOptions", "Vrije opties producten") + " " + 1,
      getTranslation("producten.form.vrijeopties.label.freeOptions", "Vrije opties producten") + " " + 2,
      getTranslation("producten.form.vrijeopties.label.freeOptions", "Vrije opties producten") + " " + 3,
      getTranslation(
        "producten" + "." + "form.vrijeopties.label.freeOptionsRequired",
        "Vrije opties producten (verplichte keuze)"
      ) +
        " " +
        1,
      getTranslation(
        "producten" + "." + "form.vrijeopties.label.freeOptionsRequired",
        "Vrije opties producten (verplichte keuze)"
      ) +
        " " +
        2,
      getTranslation(
        "producten" + "." + "form.vrijeopties.label.freeOptionsRequired",
        "Vrije opties producten (verplichte keuze)"
      ) +
        " " +
        3,
    ],
    []
  );

  const kopieer = () => {
    setSaving(true);

    let data = {};

    let copy = [...copyTo];

    if (includeTitles) {
      const titleFields = [];
      copy.forEach((field) => {
        if (titles[field]) {
          titleFields.push(titles[field]);
        }
      });
      copy = [...copy, ...titleFields];
    }

    if (useMenukaarten) {
      data = {
        type: "menukaarten",
        opties: props.opties,
        sourceProductId: props.originalProductId,
        menukaarten: [
          {
            ids: selectedMenukaart.map((m) => m.value),
            fields: copy,
          },
        ],
      };
    } else {
      data = {
        type: "producten",
        opties: props.opties,
        sourceProductId: props.originalProductId,
        products: [
          {
            ids: selectedProduct.map((p) => p.value),
            fields: copy,
          },
        ],
      };
    }

    axios.post("core/producten/kopie_opties", data).then((response) => {
      setSaving(false);
      reloadDataFromServer();
      props.toggle();
    });
  };

  const handleCopyTo = (name, event) => {
    let newState = [...copyTo];

    if (event.target.checked) {
      newState.push(name);
    } else {
      let indexKey = newState.indexOf(name);
      newState.splice(indexKey, 1);
    }

    setCopyTo(newState);
  };

  const isCopyTo = (name) => {
    return copyTo.indexOf(name) !== -1;
  };

  const disableSave = () => {
    if (useMenukaarten) {
      return selectedMenukaart === null || copyTo.length === 0;
    } else {
      return selectedProduct === null || copyTo.length === 0;
    }
  };

  const getButtonText = () => {
    if (useMenukaarten) {
      return (
        <TranslationWrapper
          tDefault={"Kopieer opties naar alle producten in menukaart"}
          tKey={"producten.modal.copyVrijeOpties.button.saveMenukaart"}
        />
      );
    } else {
      return (
        <TranslationWrapper
          tDefault={"Kopieer opties naar product"}
          tKey={"producten.modal.copyVrijeOpties.button.save"}
        />
      );
    }
  };
  const { classes } = props;
  return (
    <Dialog
      TransitionComponent={Transition}
      aria-describedby={"notice-modal-slide-description"}
      aria-labelledby={"notice-modal-slide-title"}
      classes={{
        root: classes.modalRoot,
      }}
      fullWidth
      keepMounted
      maxWidth={"xl"}
      onClose={props.toggle}
      open={props.open}
    >
      <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
        <Button
          aria-label={"Close"}
          className={classes.modalCloseButton}
          color={"transparent"}
          justIcon
          key={"close"}
          onClick={props.toggle}
        >
          <Close className={classes.modalClose} />
        </Button>
        <h4 className={classes.modalTitle}>
          <TranslationWrapper tDefault={"Kopieër product opties"} tKey={"producten.modal.copyVrijeOpties.titel"} />
        </h4>
      </DialogTitle>
      <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
        <GridContainer>
          <GridItem lg={2}>
            <FormLabel>
              <TranslationWrapper
                tDefault={"Kopieer naar menukaarten"}
                tKey={"producten.modal.copyVrijeOpties.label.useMenukaarten"}
              />
            </FormLabel>
          </GridItem>
          <GridItem lg={10}>
            <CustomSwitch
              checked={useMenukaarten}
              onChange={() => {
                setUseMenukaarten((useMenukaarten) => !useMenukaarten);
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem lg={2}>
            <FormLabel>
              <TranslationWrapper
                tDefault={"Include titles?"}
                tKey={"producten.modal.copyVrijeOpties.label.copyTitles"}
              />
            </FormLabel>
          </GridItem>
          <GridItem lg={10}>
            <CustomSwitch
              checked={includeTitles}
              onChange={() => {
                setIncludeTitles((val) => !val);
              }}
            />
          </GridItem>
        </GridContainer>
        {useMenukaarten ? (
          <GridContainer>
            <GridItem sm={2} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper
                  tDefault={"Selecteer een menukaart"}
                  tKey={"producten.modal.copyVrijeOpties.form.selectMenukaart"}
                />
              </FormLabel>
            </GridItem>
            <GridItem sm={10} xs={12}>
              <AsynchronousAutocomplete
                async={{
                  url:
                    "core/kaarten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                    menukaartVestigingId,
                  searchField: "naam",
                }}
                freeSolo={false}
                key={"kaarten"}
                multiple={true}
                onChange={(e, value) => setSelectedMenukaart(value)}
              />
            </GridItem>
          </GridContainer>
        ) : (
          <GridContainer>
            <GridItem sm={2} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper
                  tDefault={"Selecteer een product"}
                  tKey={"producten.modal.copyVrijeOpties.form.selectProduct"}
                />
              </FormLabel>
            </GridItem>
            <GridItem sm={10} xs={12}>
              <AsynchronousAutocomplete
                async={{
                  url:
                    "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                    menukaartVestigingId,
                  searchField: "naam",
                }}
                freeSolo={false}
                key={"producten"}
                multiple={true}
                onChange={(e, value) => setSelectedProduct(value)}
              />
            </GridItem>
          </GridContainer>
        )}
        <GridContainer>
          <GridItem xs={12}>
            <h4>Kopier naar:</h4>
          </GridItem>
        </GridContainer>
        {copyTofields.map((item, key) => {
          return (
            <GridContainer key={"copyFields_" + key}>
              <GridItem lg={2}>
                <CustomSwitch checked={isCopyTo(item)} onChange={(e) => handleCopyTo(item, e)} />
              </GridItem>
              <GridItem lg={10}>
                <FormLabel>{copyToFieldsNames[key]}</FormLabel>
              </GridItem>
            </GridContainer>
          );
        })}
      </DialogContent>
      <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
        <SaveButton buttonText={getButtonText()} disabled={disableSave()} onClick={kopieer} saving={saving} />
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(CopyVrijeOpties, notificationsStyle);
